export default __webpack_public_path__ + "static/media/quick_action_dialog_add_new.b1b71628.svg";